// ============================================================
// AFFILIATE LINKS
// GetResponse, Aweber, and Moosend are LIVE partner links.
// MailerLite and ConvertKit are placeholders — swap in your
// real tracking URLs once approved by those programs.
// Monday.com is stored for future CRM/workflow content.
// ============================================================
export const AFFILIATE_LINKS = {
  getresponse: "https://www.getresponse.com?a=nKAvTaqPaT",
  aweber: "https://www.aweber.com/easy-email.htm?id=561823",
  mailerlite: "https://www.mailerlite.com/signup?ref=YOUR_AFFILIATE_ID",
  moosend: "https://trymoo.moosend.com/42q0nz2k1ozh",
  convertkit: "https://kit.com/?ref=YOUR_AFFILIATE_ID",
  monday: "https://try.monday.com/vqhhe65klnwg",
};
